<template>
  <portal-light-tag
    :text="portalStatusName"
    :type="statusType"
  />
</template>

<script>
import PortalLightTag from "../tags/PortalLightTag.vue"

export default {
  name: "PortalInvoiceStatusPill",
  components: { PortalLightTag },

  props: {
    statusName: {
      required: false,
      default: "Outstanding",
      validator: (value) => {
        return [
          "Draft",
          "Overdue",
          "Outstanding",
          "Pending",
          "Pending Approval",
          "Paid",
          "Void",
          "Refunded",
          "Partial Refund",
          "Uncollectible",
          "Payment Processing",
          "Payment Failed",
          "Partially Paid",
        ].includes(value)
      },
    },
    onPaymentPage: {
      required: false,
      default: false,
      type: Boolean,
    },
    invoice: {
      required: true,
      type: Object,
    },
  },

  emits: [],

  computed: {
    portalStatusName() {
      let statusName = this.statusName
      if (this.invoice.is_overdue) {
        statusName = "Overdue"
      } else if (this.invoice.status_name === "Partially Paid") {
        statusName = "Outstanding"
      }
      switch (statusName) {
        case "Payment Failed":
          return this.onPaymentPage ? "Outstanding" : statusName
        case "Payment Processing":
          return "Paid"
        case "Payment In Review":
          return "Paid"
        default:
          return statusName
      }
    },

    statusType() {
      switch (this.portalStatusName) {
        case "Draft":
          return "yellow"
        case "Outstanding":
          return "yellow"
        case "Pending":
          return "blue"
        case "Pending Approval":
          return "blue"
        case "Paid":
          return "green"
        case "Void":
          return "red"
        case "Refunded":
          return "red"
        case "Partial Refund":
          return "red"
        case "Uncollectible":
          return "red"
        case "Overdue":
          return "red"
        case "Payment Processing":
          return "green"
        case "Partially Paid":
          return "green"
        case "Payment Failed":
          return "red"
      }

      return "gray"
    },
  },
}
</script>
